import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Send, CheckCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CTASection() {
  const [formState, setFormState] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setFormState('submitting');
    // Simulate API call
    setTimeout(() => {
      setFormState('success');
    }, 1500);
  };
  return <section id="schedule" className="py-24 bg-gray-50 relative overflow-hidden" data-id="element-53">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-54">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden" data-id="element-55">
          <div className="grid md:grid-cols-5" data-id="element-56">
            {/* Left Side - Info */}
            <div className="md:col-span-2 bg-black text-white p-10 flex flex-col justify-between relative overflow-hidden" data-id="element-57">
              <div className="relative z-10" data-id="element-58">
                <h3 className="text-2xl font-bold mb-4" data-id="element-59">Start Your Journey</h3>
                <p className="text-gray-400 mb-8" data-id="element-60">
                  Schedule your free trial class today. No obligation, just an
                  opportunity to see if we're the right fit for you.
                </p>
                <div className="space-y-4" data-id="element-61">
                  <div className="flex items-start gap-3" data-id="element-62">
                    <div className="w-8 h-8 rounded-full bg-[#00D4FF]/20 flex items-center justify-center text-[#00D4FF] font-bold text-sm" data-id="element-63">
                      1
                    </div>
                    <p className="text-sm text-gray-300 pt-1" data-id="element-64">
                      Fill out the form
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-65">
                    <div className="w-8 h-8 rounded-full bg-[#00D4FF]/20 flex items-center justify-center text-[#00D4FF] font-bold text-sm" data-id="element-66">
                      2
                    </div>
                    <p className="text-sm text-gray-300 pt-1" data-id="element-67">
                      We'll contact you to confirm
                    </p>
                  </div>
                  <div className="flex items-start gap-3" data-id="element-68">
                    <div className="w-8 h-8 rounded-full bg-[#00D4FF]/20 flex items-center justify-center text-[#00D4FF] font-bold text-sm" data-id="element-69">
                      3
                    </div>
                    <p className="text-sm text-gray-300 pt-1" data-id="element-70">
                      Come in for your free class!
                    </p>
                  </div>
                </div>
              </div>

              {/* Abstract background shapes */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-[#00D4FF] opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-71" />
              <div className="absolute bottom-0 left-0 w-64 h-64 bg-[#FF6B35] opacity-10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-72" />
            </div>

            {/* Right Side - CTA */}
            <div className="md:col-span-3 p-10 flex flex-col items-center justify-center" data-id="element-73">
              <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-74">
                Ready to Get Started?
              </h3>
              <p className="text-gray-600 mb-8 text-center" data-id="element-75">
                Click below to schedule your complimentary free week
              </p>
              <Link to="/free-trial" className="bg-[#00D4FF] text-black font-bold py-4 px-8 rounded-lg uppercase tracking-wider hover:bg-[#33ddff] transition-colors flex items-center justify-center gap-2 shadow-[0_0_20px_rgba(0,212,255,0.3)]" data-id="element-76">
                Schedule Free Trial
                <Send size={18} data-id="element-77" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}